import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorService } from '@/app/core/errors/error.service';
import { AuthenticationService } from '@/app/core/authentication/authentication.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private handlingUnauthorized = false;

  constructor(
    private errorService: ErrorService,
    private authenticationService: AuthenticationService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Prevent multiple simultaneous 401s from triggering multiple logouts
          if (!this.handlingUnauthorized) {
            this.handlingUnauthorized = true;
            this.authenticationService.logout();
          }
          // Re-throw error so callers can clean up UI state before logout redirect
          return throwError(() => error);
        }

        if (error.error instanceof ErrorEvent) {
          this.errorService.handleError(error.error);
        } else {
          this.errorService.handleError(error);
        }

        return throwError(() => error);
      })
    );
  }
}
